import { createFileRoute } from "@tanstack/react-router";
import MemberDashboard from "@/pages/MemberDashboard";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/member")({
  head: () => ({
    meta: [
      { title: "Founding Members Programme | Statlign" },
      { name: "description", content: "The Statlign Founding Member area: credits, early access to new markets, and a permanent founding number. Sign in to view your dashboard." },
      { property: "og:title", content: "Founding Members Programme | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "The Statlign Founding Member area: credits, early access to new markets, and a permanent founding number. Sign in to view your dashboard." },
      { name: "twitter:title", content: "Founding Members Programme | Statlign" },
      { name: "twitter:description", content: "The Statlign Founding Member area: credits, early access to new markets, and a permanent founding number. Sign in to view your dashboard." },
    ],
  }),
  component: () => (
    <MainLayout>
      <MemberDashboard />
    </MainLayout>
  ),
});
